/* eslint-disable no-nested-ternary */
import { Button, Grid } from '@material-ui/core';
import { FormikTextFieldPx, useMutation, useToast, useAuth } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { updateSchoolContract } from '@webapps/business';
import { useFormik } from 'formik';

const SchoolContract = ({ infosVitrine = [], refetchInfo }) => {
  const {
    classes,
    cx,
    css,
    theme: { spacing, fontSizes },
  } = useStyles(styles);

  const { addToast } = useToast();
  const { idUser } = useAuth();

  const {
    isSuccess,
    isError,
    mutateAsync: mutateUpdateStudentContract,
  } = useMutation(updateSchoolContract);

  const formik = useFormik({
    initialValues: {
      addressDetails: infosVitrine?.addressDetails || '',
      number: infosVitrine?.number || '',
      street: infosVitrine?.street || '',
      uai: infosVitrine?.uai || '',
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      await mutateUpdateStudentContract({ id: idUser, data: {...values} });
    },
  });

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Informations mises à jour avec succès',
      });
      refetchInfo();
    } else if (isError) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [isSuccess, isError]);

  return (
    <Grid spacing={3} xs={12} className={classes.container}>
      <Grid item md={12} className={classes.card}>
        <div className={classes.title}>Informations des données requises lors de la signature d'un contrat</div>
        <Grid container xs={12} className={classes.btnsContainer2}>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Complément d'adresse (ex: étage, porte...)"
              name="addressDetails"
              value={formik.values.addressDetails}
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="N° de rue"
              name="number"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="Voie"
              name="street"
            />
          </Grid>
          <Grid item xs={3} className={cx(classes.textfield, classes.textfieldName)}>
            <FormikTextFieldPx
              formik={formik}
              fullWidth
              label="UAI"
              name="uai"
            />
          </Grid>
          <Button
            className={classes.btnDelete}
            onClick={formik.handleSubmit}
            variant="contained"
          >
            Enregistrer
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    padding: spacing(2.5),
  },
  title: {
    fontWeight: 500,
    fontSize: fontSizes(18),
    color: '#152652',
    marginBottom: spacing(2.5),
    fontFamily: 'Rubik',
  },
  label: {
    //    fontSize: fontSizes(16),
    fontSize: fontSizes(16),
    fontWeight: 600,
    color: '#152652',
    '@media (max-width:1380px)': { fontSize: fontSizes(15) },
    '@media (max-width:1278px)': { fontSize: fontSizes(14), },
    '@media (max-width:1227px)': { fontSize: fontSizes(13), },
    '@media (max-width:1020px)': { fontSize: fontSizes(16), },
  },
  password: {
    marginLeft: spacing(2.5),
    marginBottom: spacing(2.5),
  },
  textfield: {
    marginBottom: spacing(2.5),
    flexBasis: 'auto',
  },
  textfieldName: {
    width: '49%',
  },
  infoBox: {
    padding: spacing(4, 2.5, 2.5, 1.5),
    borderRadius: '5px',
    color: '#152652',
    "-webkit-text-fill-color" : "#152652",
    fontSize: fontSizes(16),
    fontFamily: 'Rubik',
    height: '30px',
    backgroundColor: '#F8F8F8',
    display: 'flex',
    alignItems: 'center',
  },
  infoBoxDisabled: {
    borderRadius: '5px',
    color: '#959DB1',
    backgroundColor: '#FFFFFF',
  },
  btnCancel : {
    marginLeft: spacing(2),
    backgroundColor: 'crimson',
    '&:hover' : {
      backgroundColor: 'red',
    },
  },
  btnDelete: {
    marginTop: spacing(2.5),
    float: 'right',
    backgroundColor: 'crimson',
    '&:hover' : {
      backgroundColor: 'red',
    },
    '@media only screen and (max-width:506px)': { width: '100%', flexBasis: '100%' },
  },
  deleteAccount: {
    textAlign: 'center',
    marginBottom: '16px',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  btnLogout: {
    marginTop: spacing(2.5),
    backgroundColor: 'white',
    '@media only screen and (max-width:506px)': { width: '100%', flexBasis: '100%' },
  },
  btnLogoutContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'self-end',
    flexWrap: 'wrap',
  },
  btnsContainer2: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  phoneInput: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F8F8F8',
      border: "2px solid #E9E9F0",
      borderRadius: 5,
      padding: spacing(4, 2),
      height: '100%',
      color: '#737373',
    },
  },
  phoneInputError: {
    height: '100%',
    '& > *': {
      backgroundColor: '#F8F8F8',
      border: '2px solid red',
      borderRadius: 5,
      padding: spacing(4, 2),
      height: '100%',
      color: '#f44336',
    },
  },
  phoneError: {
    display: 'flex',
    width: '100%',
    '& > *': {
      width: '50%',
    },
  },
  phoneDisabled: {
    '& > *': {
      backgroundColor: 'white',
    },
  }
});

SchoolContract.propTypes = {
  infosVitrine: PropTypes.object,
  refetchInfo: PropTypes.func,
};

export default SchoolContract;
